import React, { useState, useEffect } from 'react';
import Pagination from '../pagination/Pagination';
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import { FiShoppingCart, FiEye, FiTrash2 } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import apiClient from '../../services/apiClient';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { addToCart, removeFromCart } from '../../features/cart/cartSlice';
import { IMAGE_PATH } from '../../utils/constants';

const Wishlist = () => {
  const [imageHovered, setImageHovered] = useState(null);
 
  const [currentPage, setCurrentPage] = useState(1);
  const [wishlist, setWishlist] = useState({ combo: [], normal: [] });
  const [isLoading, setLoading] = useState(true);
  const productsPerPage = 8;
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const cartItems = useSelector(state => state.cart.items)
  const breadcrumbItems = [
    { label: "Home", url: "/" },
    { label: "Wishlist" },
  ];

  useEffect(() => {
    const fetchWishList = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(`/wishlist/${user.id}`);
        setWishlist(res.data);
      } catch (error) {
        console.error("Error fetching wishlist:", error);
        toast.error("Failed to load wishlist");
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchWishList();
    }
  }, [user]);

  
  const allWishlistItems = [...wishlist.combo, ...wishlist.normal];
  // console.log(allWishlistItems)
  // Toggle wishlist item
  const toggleWishlist = async (productId, productType) => {
    try {
      await apiClient.delete(`/wishlist/${productId}`);
      // Update local state
      if (productType === 'combo') {
        setWishlist(prev => ({
          ...prev,
          combo: prev.combo.filter(item => item.id !== productId)
        }));
      } else {
        setWishlist(prev => ({
          ...prev,
          normal: prev.normal.filter(item => item.id !== productId)
        }));
      }
      toast.success("Removed from wishlist");
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      toast.error("Failed to remove from wishlist");
    }
  };

  // Toggle cart item
  const toggleCart = (item,isCombo) => {
    let newProduct = {};
    if(isCombo){
     newProduct = {
        ...item,
        is_combo: true,
        name: item.title,
        sale_price: item.combo_price,
        price: item.products.reduce(
          (total, product) => total + parseFloat(product.price || product.price),
          0
        ),
        media: item.image_path ? [{ file_path: item.image_path, file_type: "image" }] : [],
      }
    }else{
      newProduct = {
        ...item,
        is_combo: false,
        
      }
    }
    if (!cartItems.some(cat => cat.id === newProduct.id)) {

      dispatch(addToCart({...newProduct , quantity : 1}))
      toast.success("Removed from cart");
    } else {
      dispatch(removeFromCart(newProduct.id));
      toast.success("Added to cart");
    }
  };

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = allWishlistItems.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(allWishlistItems.length / productsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Get first two images for a product
  const getProductImages = (product) => {
    const media = product?.media || (product?.image_path ? [{ file_path: product.image_path }] : []);
    return {
      image1: media[0]?.file_path || '',
      image2: media[1]?.file_path || media[0]?.file_path || ''
    };
  };

  if (isLoading) {
    return (
      <div id='Wishlist'>
        <div className="BreadCrumbsBox">
          <div className="container">
            <Breadcrumbs items={breadcrumbItems} />
          </div>
        </div>
        <div className='container'>
          <div className='WishlistMain'>
            <div className="homProductCardList">
              {Array(4).fill(0).map((_, index) => (
                <div className="ProductBox" key={`skeleton-${index}`}>
                  <Skeleton height={200} />
                  <Skeleton count={3} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (allWishlistItems.length === 0) {
    return (
      <div id='Wishlist'>
        <div className="BreadCrumbsBox">
          <div className="container">
            <Breadcrumbs items={breadcrumbItems} />
          </div>
        </div>
        <div className='container'>
          <div className='empty-wishlist'>
            <h3>Your wishlist is empty</h3>
            <p>You haven't added any items to your wishlist yet</p>
            <Link to="/products" className="btn-primary">
              Browse Products
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id='Wishlist'>
      <div className="BreadCrumbsBox">
        <div className="container">
          <Breadcrumbs items={breadcrumbItems} />
        </div>
      </div>
      <div className='container'>
        <div className='WishlistMain'>
          <div className="homProductCardList">
            {currentProducts.map((item) => {
              const product = item.product_type == 'normal' ? item.product : item.combo_product;
              const productType = item.product_type;
              const { image1, image2 } = getProductImages(product);
              const isCombo = productType === 'combo';
              if (!product) return null;
              const isInCart = cartItems.some(cartItem => cartItem.id === product?.id);
       
              return (
                <div className="ProductBox" key={`${productType}-${product?.id}`}>
                  
                  <div 
                    className="wishlistIcon"
                    onClick={() => toggleWishlist(item.id, productType)}
                  >
                    <FaHeart className="active" />
                  </div>

                  <Link 
                    to={isCombo ? `/combos/${product.id}` : `/products/${product.id}`} 
                    className="productLink"
                  >   
                    <div
                      className="ProductImage"
                      onMouseEnter={() => setImageHovered(product.id)}
                      onMouseLeave={() => setImageHovered(null)}
                    >
                      {image1 && (
                        <img
                          src={IMAGE_PATH + image1}
                          className={imageHovered === product.id ? "fade-out" : "fade-in"}
                          alt={product.name || product.title}
                          loading="lazy"
                        />
                      )}
                      {image2 && (
                        <img
                          src={IMAGE_PATH + image2}
                          className={imageHovered === product.id ? "fade-in" : "fade-out"}
                          alt={product.name || product.title}
                          loading="lazy"
                        />
                      )}
                    </div>

                    <div className="ProductText">
                      <h3>{product.name || product.title}</h3>
                      <div className="priceContainer">
                        {isCombo ? (
                          <span className="offerPrice">₹{product.combo_price}</span>
                        ) : (
                          <>
                            {product.sale_price && product.sale_price !== product.price && (
                              <p className="originalPrice">₹{product.price}</p>
                            )}
                            <span className="offerPrice">₹{product.sale_price || product.price}</span>
                          </>
                        )}
                      </div>
                      {isCombo && (
                        <p className="combo-label">{product.products?.length || 0} items combo</p>
                      )}
                    </div>
                  </Link>

                  <button 
                    className={`addToCartBtn ${isInCart ? 'inCart' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleCart(product,isCombo);
                    }}
                  >
                    {isInCart ? (
                      <FiTrash2 className="cart-icon" />
                    ) : (
                      <FiShoppingCart className="cart-icon" />
                    )}
                    {isInCart ? 'Remove from Cart' : 'Add to Cart'}
                  </button>
                </div>
              );
            })}
          </div>
          {totalPages > 1 && (
            <Pagination 
              currentPage={currentPage} 
              totalPages={totalPages} 
              onPageChange={paginate} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Wishlist;